<template>
  <div class="webinar-modal-background fade">
    <div class="webinar-modal-content">
      <img
        class="webinar-modal-close-icon"
        :src="closeIcon"
        @click="closeModal"
      />
      <slot></slot>
    </div>
  </div>
</template>

<script>
import closeIcon from '@/assets/images/close-icon.png'

export default {
  name: 'BaseModal',
  data() {
    return {
      closeIcon: closeIcon
    }
  },
  methods: {
    closeModal() {
      this.$emit('closeModal')
    }
  }
}
</script>

<style lang="scss" scoped>
.webinar-modal-background {
  box-sizing: border-box;
  position: fixed;
  background-color: rgba($grey-800, 0.8);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 $spacing-3;
  @media (min-width: $breakpoint-s) {
    padding: 0;
  }
}
.webinar-modal-content {
  position: relative;
  box-sizing: border-box;
  background-color: $white;
  width: 100%;
  max-width: $breakpoint-s;
  padding: $spacing-6 $spacing-5;
  box-shadow: -1px -2px 42px -19px rgba(0, 0, 0, 0.74);
}

.webinar-modal-close-icon {
  cursor: pointer;
  position: absolute;
  top: $spacing-3;
  right: $spacing-3;
  width: $font-size-s;
  height: $font-size-s;
}
</style>
